/*
 * *****************************************************************************
 * File: main.js (/src/components/main.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 4:54:39 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Thursday, 1st April 2021 10:30:39 am
 * *****************************************************************************
 */
import React from 'react'
import styled from '@emotion/styled'

const Main = ({ children, ...props }) => (
    <Container {...props}>
        <Inner>{children}</Inner>
    </Container>
)

export default Main

const Container = styled.main`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`

const Inner = styled.div`
    width: 100%;
    max-width: 1250px;
    box-sizing: border-box;
    padding: 40px 50px;
    min-height: 75vh;
    background: #222222;
    color: #ffffff;
    border-radius: 7px;
    box-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
    font-size: 17px;
    @media (max-width: 1250px) {
        border-radius: 0;
    }
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        padding: 40px 6.1vw;
    }
`
